<template>
  <!-- 车费分摊 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('admin:dispatch:saveAllocationCarFee')"
          class="glo_btnItems glo_bgcMainColor"
          @click="submit"
          >保存
        </el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:postingAllocationCarFee')"
          class="glo_btnItems"
          @click="postingAllocationCarFee"
          >过账
        </el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:backPostingAllocationCarFee')"
          class="glo_btnItems"
          @click="backPostingAllocationCarFee"
          >反过账
        </el-button>
      </div>

      <!-- <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns> -->
    </div>

    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItems" label="发车批次号:">
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.number"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="总费用:">
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.totalFee"
          ></el-input>
        </el-form-item>
        <el-button @click="fenTan" class="cbftBtns glo_bgcMainColor"
          >成本分摊</el-button
        >
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <!-- <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column> -->
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'allocationCost' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <el-input
                class="inputFare"
                placeholder="请输入"
                v-model="tableData[scope.$index].allocationCost"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'goodsName' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="rowClickdiv" @click="getGoodsNameDetails(scope.row)">
                货物明细
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页 -->
    <!-- <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging> -->
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm"
          :model="dialogForm"
          label-width="120px"
          :rules="rulesForm"
        >
          <div class="itemsRows">
            <el-form-item
              class="dialogFormItems"
              prop="aaa"
              label="发车合同编号:"
            >
              <el-input
                v-model="dialogForm.aaa"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="itemTydw">
            <el-form-item
              class="dialogFormItems tydw"
              prop="aaa"
              label="托运单位:"
            >
              <el-input
                v-model="dialogForm.aaa"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItems tydh"
              prop="aaa"
              label="托运联系电话:"
            >
              <el-input
                v-model="dialogForm.aaa"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="itemTydw">
            <el-form-item
              class="dialogFormItems tydw"
              prop="aaa"
              label="收货单位:"
            >
              <el-input
                v-model="dialogForm.aaa"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItems tydh"
              prop="aaa"
              label="托运联系电话:"
            >
              <el-input
                v-model="dialogForm.aaa"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item class="dialogFormItems" prop="a1" label="始发城市:">
            <el-input v-model="dialogForm.a1" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a2" label="目的城市:">
            <el-input v-model="dialogForm.a2" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a3" label="货物城市:">
            <el-input v-model="dialogForm.a3" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a4" label="总件数:">
            <el-input v-model="dialogForm.a4" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a5" label="总重量:">
            <el-input v-model="dialogForm.a5" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a6" label="总体积:">
            <el-input v-model="dialogForm.a6" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="a7" label="预计到达时间:">
            <el-date-picker
              v-model="dialogForm.a7"
              value-format="yyy-MM-dd HH:mm:ss"
              type="datetime"
              default-time="12:00:00"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a8" label="要求到达时间:">
            <el-date-picker
              v-model="dialogForm.a8"
              value-format="yyy-MM-dd HH:mm:ss"
              type="datetime"
              default-time="12:00:00"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            style="width: 100%"
            prop="a9"
            label="承运单位:"
          >
            <el-input v-model="dialogForm.a9" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="a10" label="司机姓名:">
            <el-input v-model="dialogForm.a10" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a11" label="身份证号:">
            <el-input v-model="dialogForm.a11" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a12" label="联系电话:">
            <el-input v-model="dialogForm.a12" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a13" label="家庭电话:">
            <el-input v-model="dialogForm.a13" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a14" label="司机住址:">
            <el-input v-model="dialogForm.a14" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a15" label="车主姓名:">
            <el-input v-model="dialogForm.a15" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a16" label="行驶证号:">
            <el-input v-model="dialogForm.a16" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a17" label="驾驶证号:">
            <el-input v-model="dialogForm.a17" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a18" label="发动机号:">
            <el-input v-model="dialogForm.a18" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a19" label="车架号码:">
            <el-input v-model="dialogForm.a19" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a20" label="车型:">
            <el-input v-model="dialogForm.a20" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a21" label="挂车车牌号:">
            <el-input v-model="dialogForm.a21" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a22" label="车主地址:">
            <el-input v-model="dialogForm.a22" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a23" label="附加费证号:">
            <el-input v-model="dialogForm.a23" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a24" label="运营证号:">
            <el-input v-model="dialogForm.a24" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a25" label="保险单号:">
            <el-input v-model="dialogForm.a25" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a26" label="同行驾驶员:">
            <el-input v-model="dialogForm.a26" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="a27"
            label="同行驾驶证号:"
          >
            <el-input v-model="dialogForm.a27" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a28" label="养路费号:">
            <el-input v-model="dialogForm.a28" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a29" label="单位地址:">
            <el-input v-model="dialogForm.a29" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="a30" label="车属单位:">
            <el-input v-model="dialogForm.a30" placeholder="请输入"></el-input>
          </el-form-item>
          <!-- 
          <el-form-item class="dialogFormItems" prop="a6" label="adas:">
            <el-select v-model="dialogForm.a6" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="dislogFormTextarea" prop="ccc" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.ccc"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item> -->
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 查看货物明细 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3()"
    >
      <div class="glo_Table" v-if="isShowDialog3">
        <el-table header-align="center" :data="goodsNameData" border stripe>
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          >
          </el-table-column>
          <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>
          <template v-for="(item, index) in goodsTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            >
            </el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //  -----  查询  ------
      queryData: {
        number: "",
        totalFee: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "运输里程数",
          field: "transportMileage",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "分摊数值",
          field: "allocationValue",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "货物明细",
          field: "goodsName",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "成本分摊",
          field: "allocationCost",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [
        "billingWeight",
        "transportMileage",
        "allocationValue",
        "allocationCost",
      ], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "FareAllocation", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {},
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog3: false,
      dialogTitle3: "弹窗标题",
      diaWidth3: "80%",

      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      allocationValue: 0, //分摊数值
      goodsNameData: [],
      goodsTableHeard: [
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "address",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物编号",
          field: "goodsNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积重量",
          field: "volumeWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;;
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    //
    let dispatchId = this.$route.query.dispatchId || "";
    if (dispatchId) {
      this.dispatchId = dispatchId;
      this.getData();
    }
  },
  mounted() {
    //计算获取表格高度
    // this.fetTableHeight();
  },
  watch: {},
  methods: {
    // 查看货物明细:
    getGoodsNameDetails(row) {
      this.$API
        .wtl_getWaybillItems({ waybillSplitId: row.waybillId })
        .then((res) => {
          this.goodsNameData = res.data.result || [];
          this.isShowDialog3 = true;
        });
    },
    // 保存
    submit() {
      let carFeeList = JSON.parse(JSON.stringify(this.tableData));
      let param = {
        dispatchId: this.dispatchId,
        totalAmount: this.queryData.totalFee,
        carFeeList: carFeeList || [],
      };
      this.$API.saveAllocationCarFee(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
      });
    },
    // 过账
    postingAllocationCarFee() {
      let carFeeList = JSON.parse(JSON.stringify(this.tableData));

      this.$confirm("是否对该车费分摊进行过账?", "提示:")
        .then(() => {
          let param = {
            dispatchId: this.dispatchId,
            totalAmount: this.queryData.totalFee,
            carFeeList: carFeeList || [],
          };
          this.$API.postingAllocationCarFee(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
          });
        })
        .catch(() => {});
    },
    // 反过账
    backPostingAllocationCarFee() {
      // let carFeeList = JSON.parse(JSON.stringify(this.tableData));

      this.$confirm("是否对该车费分摊进行 反过账?", "提示:")
        .then(() => {
          let param = {
            dispatchId: this.dispatchId,
          };
          this.$API.backPostingAllocationCarFee(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
          });
        })
        .catch(() => {});
    },
    fenTan() {
      let nums = this.queryData.totalFee * 1 || 0;
      if (nums == 0) {
        this.$message.error("请输入总费用");
        return false;
      }
      let allocationValues = this.allocationValue || 0;
      if (allocationValues <= 0) {
        this.$message.error("总分摊数值不能小于0");
        return false;
      }

      let arrs = JSON.parse(JSON.stringify(this.tableData)) || [];

      //循环arrs 摊分成本, 最后一条数据的成本=用总费用-前面的合计
      let totalCost = 0;
      arrs.forEach((item, index) => {
        if (index < arrs.length - 1) {
          let num1 = this.$TOOLS.divide(item.allocationValue, allocationValues); // 占比
          console.log("占比", num1);
          let num2 = this.$TOOLS.mul(nums, num1).toFixed(2);
          console.log("num2", num2);
          item.allocationCost = num2;
          totalCost += parseFloat(num2);
        } else {
          item.allocationCost = this.$TOOLS.sub(nums, totalCost).toFixed(2);
        }
      });

      // arrs.forEach((item) => {
      //   let num1 = this.$TOOLS.divide(item.allocationValue, allocationValues); //占比
      //   console.log("占比", num1);
      //   let num2 = this.$TOOLS.mul(nums, num1).toFixed(3);
      //   console.log("num2", num2);
      //   item.allocationCost = num2;
      // });

      this.tableData = arrs;
    },
    // 修改运单
    transportPlan() {
      this.isShowDialog = true;
      this.dialogTitle = "新建发车合同";
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia3() {
      this.isShowDialog3 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      this.isShowDialog3 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          yd: "123",
        },
      });
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      this.$API
        .getDispatchCarFeeList({ dispatchId: this.dispatchId })
        .then((res) => {
          if (res.data.status === "success") {
            this.tableData = res.data.result.carFeeList || [];
            this.queryData.number = res.data.result.number;
            this.queryData.totalFee = res.data.result.totalFee;

            if (this.tableData.length > 0) {
              let sumNum = 0;
              this.tableData.forEach((item) => {
                sumNum = this.$TOOLS
                  .add(sumNum, item.allocationValue)
                  .toFixed(3);
              });
              // 总的分摊数值
              this.allocationValue = sumNum;
              console.log(this.allocationValue);
            }
            this.$nextTick(() => {
              this.fetTableHeight();
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        number: "",
        totalFee: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    handleCommand_dc(command) {
      //  导出操作
      if (command === "dc") {
        // 导出
        this.exportBtn();
      } else if (command === "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command === "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    3
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + 60 + 20; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
      }
    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort() {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            this.myTableHeard = this.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < this.myTableHeard.length; i++) {
            if (this.myTableHeard[i].isTotal) {
              totalArr.push(this.myTableHeard[i].field);
            }
          }
          this.totalArr = totalArr;
        });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },

    // ==========排序表头的组件方法==========
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let sign = "";
      //   let param = {
      //     groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      //     sortName: this.sortName, //综合查询接口路径
      //     sortObject: JSON.stringify(sortObject),
      //     sign: sign,
      //   };
      //   this.$API.pushFindFieldSort(param).then((res) => {
      //     this.$message.success(res.data.message || "操作成功");
      //     this.getGroupFindFieldSort();
      //   });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}
.rowClickdiv {
  color: blue;
  cursor: pointer;
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}

.diaForm {
  .itemsRows {
    width: 100%;
  }

  .itemTydw {
    width: 100%;
    display: flex;
    .tydw {
      flex: 2;
    }

    .tydh {
      flex: 1;
    }
  }
}

// .glo_Table {
//   .inputFare {
//   }
// }

.glo_form {
  /deep/ .el-button {
    height: 30px;
    line-height: 30px;
    padding: 0 15px !important;
  }
  //   .cbftBtns {

  //   }
}
</style>
